import React from "react";
import useAIChat from "@/hooks/useAIChat";
import ChatHeader from "@/components/chat/ChatHeader";
import MessageList from "@/components/chat/MessageList";
import MessageInput from "@/components/chat/MessageInput";

const SUGGESTIONS = [
  "Best material for an outdoor drone arm?",
  "Tolerance for a press-fit M3 brass insert?",
  "Recommend layer height for a hexapod gear.",
  "How to print a vase-mode lamp in Silk-PLA?",
];

export default function AIAssistant() {
  const { messages, streaming, send } = useAIChat();

  return (
    <section
      id="assistant"
      data-testid="ai-assistant-section"
      className="relative py-24 sm:py-32 border-t border-white/5 bg-[#0C0C0E]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <span className="label-overline">/ 05 — AI consultant</span>
          <h2 className="font-display text-4xl sm:text-5xl mt-6 mb-6 leading-[1.05] font-semibold tracking-tight">
            On-call print advisor,<br />24 × 7.
          </h2>
          <p className="text-zinc-400 leading-relaxed mb-8">
            Powered by Gemini 2.5. Get instant guidance on material choice,
            tolerances, overhang rules, infill strategy and DFM — before you
            commit to a print.
          </p>

          <div className="space-y-2">
            <div className="label-overline mb-2">Try asking</div>
            {SUGGESTIONS.map((s) => (
              <button
                key={s}
                data-testid={`ai-suggestion-${s.slice(0, 10)}`}
                onClick={() => send(s)}
                disabled={streaming}
                className="block w-full text-left text-sm font-mono px-4 py-3 border border-white/10 text-zinc-300 hover:border-[#FF5722] hover:text-white transition-colors disabled:opacity-40"
              >
                <span className="text-[#FF5722] mr-2">›</span>
                {s}
              </button>
            ))}
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="border border-white/10 bg-black flex flex-col h-[640px]">
            <ChatHeader />
            <MessageList messages={messages} streaming={streaming} />
            <MessageInput onSend={send} disabled={streaming} />
          </div>
        </div>
      </div>
    </section>
  );
}
